import React from 'react';
import PropTypes from 'prop-types';

import PhoneNumberInput from 'react-phone-number-input';
import localeRU from 'react-phone-number-input/locale/ru';
import 'react-phone-number-input/style.css';

import { makeStyles } from '@mui/styles';

import decorate from '_core/utils/decorate';
import * as component from '_core/utils/component';
import { TextInput } from '_core/components/TextInput';

const apiServer = '';

const InputComponent = React.forwardRef(
  (
    {
      inputComponentRef,
      inputClassName,
      inputOnFocus,
      inputOnBlur,
      inputOnChange,
      ...props
    },
    ref
  ) => (
    <input
      ref={component.ref(ref, inputComponentRef)}
      {...props}
      className={component.className(props.className, inputClassName)}
      onFocus={component.eventProxy(props.onFocus, inputOnFocus)}
      onBlur={component.eventProxy(props.onBlur, inputOnBlur)}
      onChange={component.eventProxy(props.onChange, inputOnChange)}
    />
  )
);

const PhoneInput = decorate(
  class extends React.PureComponent {
    static decorateWith = {};

    static decorateForwardRef = 'inputComponentRef';

    static propTypes = {
      onChange: PropTypes.func
    };

    static defaultProps = {
      onChange: () => null
    };

    constructor(props) {
      super(props);
    }

    render() {
      const { ...props } = this.props;

      return (
        <PhoneNumberInput
          international
          labels={localeRU}
          countryCallingCodeEditable={false}
          inputComponent={InputComponent}
          flagUrl={apiServer + '/data/images/global/icons/flags/{XX}.svg'}
          {...props}
        />
      );
    }
  }
);

export const useMuiInputStyle = makeStyles((theme) => ({
  label: {
    transform: 'translate(45px, 21px) scale(1)',

    '&.MuiInputLabel-shrink': {
      transform: 'translate(0, 1.5px) scale(0.75)'
    }
  },

  phoneInput: {
    width: '100%'
  }
}));

const MuiInputComponent = React.forwardRef(
  ({ className, inputRef, onFocus, onBlur, onChange, ...props }, ref) => {
    return (
      <PhoneInput
        ref={component.ref(ref, inputRef)}
        {...props}
        inputClassName={className}
        inputOnFocus={onFocus}
        inputOnBlur={onBlur}
        inputOnChange={onChange}
      />
    );
  }
);

export default PhoneInput;

export const MuiPhoneInput = (props) => {
  const classes = useMuiInputStyle(props);

  return (
    <TextInput
      {...props}
      labelProps={{ className: classes.label }}
      inputProps={{
        inputComponent: MuiInputComponent
      }}
    />
  );
};
